import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface PilotSlide5Props {
  isDark?: boolean;
}
export function PilotSlide5({
  isDark = false
}: PilotSlide5Props) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  return <motion.div className="h-full w-full overflow-y-auto overflow-x-hidden" variants={containerVariants} initial="hidden" animate="visible" data-id="element-704">
      <div className="min-h-full flex flex-col justify-center items-center max-w-4xl mx-auto px-4 sm:px-8 py-16 sm:py-20 text-center" data-id="element-705">
        <motion.div variants={itemVariants} className="mb-6 sm:mb-8 px-4 sm:px-6 py-2 bg-heliona-mint/10 border border-heliona-mint/30 rounded-full" data-id="element-706">
          <span className={`font-medium text-xs sm:text-sm tracking-wide uppercase ${isDark ? 'text-heliona-mint' : 'text-heliona-mint-dark'}`} data-id="element-707">
            Understanding the Economics
          </span>
        </motion.div>

        <motion.div variants={itemVariants} className={`inline-flex items-center gap-2 sm:gap-3 px-4 sm:px-8 py-3 sm:py-4 rounded-full backdrop-blur-sm mb-6 sm:mb-8 ${isDark ? 'bg-white/5 border border-white/10' : 'bg-heliona-navy/10 border border-heliona-navy/20'}`} data-id="element-708">
          <div className="w-2 h-2 rounded-full bg-heliona-mint animate-pulse" data-id="element-709" />
          <span className={`font-medium tracking-wide text-xs sm:text-sm ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-710">
            For CFOs, Finance, and Executive Buyers
          </span>
        </motion.div>

        <motion.h1 variants={itemVariants} className={`text-2xl sm:text-4xl font-serif font-medium mb-4 sm:mb-6 leading-tight px-4 ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-711">
          Now let's explore why this investment makes financial sense
        </motion.h1>

        <motion.p variants={itemVariants} className={`text-base sm:text-xl mb-8 sm:mb-12 max-w-2xl leading-relaxed px-4 ${isDark ? 'text-white/80' : 'text-heliona-text-gray'}`} data-id="element-712">
          We'll walk through the economic case for leadership wellness and how
          Heliona delivers measurable ROI
        </motion.p>

        <motion.div variants={itemVariants} className={`flex items-center gap-2 sm:gap-3 ${isDark ? 'text-heliona-mint' : 'text-heliona-mint-dark'}`} data-id="element-713">
          <span className="font-medium text-sm sm:text-base" data-id="element-714">
            Continue to see the numbers
          </span>
          <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-715" />
        </motion.div>
      </div>
    </motion.div>;
}